module.exports = __webpack_public_path__ + "img/stratup-brand-logo-6.9b0295c8.png";